import { render, staticRenderFns } from "./createArticle.vue?vue&type=template&id=44d2e64e&scoped=true&"
import script from "./createArticle.vue?vue&type=script&lang=js&"
export * from "./createArticle.vue?vue&type=script&lang=js&"
import style0 from "./createArticle.vue?vue&type=style&index=0&id=44d2e64e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d2e64e",
  null
  
)

export default component.exports